module.exports = __webpack_public_path__ + "static/media/right_drive.55a0bd12.png";